<div class="error-404">
    <span>
        Error 404
    </span>
</div>